import { MotionModeString } from '@marsinet/commons';

export const getMotionModeStringLabels = (t: (key: string) => string) => ({
  [MotionModeString.AUTO]: t('automatic'),
  [MotionModeString.TRIGGER_FORCE]: t('intention'),
  [MotionModeString.AAN]: t('assistance_as_needed'),
  [MotionModeString.AAN2]: t('assistance_as_needed'),
});
